export { PropertyDetailsView } from './activities/propertyDetailsView';
export { GiftCardPurchaseView } from './giftCardPurchaseView';
export { GiftCardShowcase } from './giftcardShowcase';
export { CustomerTemplate } from './template';
